import styled from 'styled-components';

export const InputContainer = styled.div`
  width: 180px;
`;
